import React from "react";
import { Text } from "components";
import { IMessage, MessageTextProps } from "react-native-gifted-chat";

export default function ChantText(props: MessageTextProps<IMessage>) {
  return (
    <Text size={"lg"} style={{ padding: 10 }}>
      {props.currentMessage?.text}
    </Text>
  );
}
